import { render, staticRenderFns } from "./msv3.vue?vue&type=template&id=99f64f50&scoped=true"
import script from "./msv3.vue?vue&type=script&lang=js"
export * from "./msv3.vue?vue&type=script&lang=js"
import style0 from "./msv3.vue?vue&type=style&index=0&id=99f64f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f64f50",
  null
  
)

export default component.exports